// src/api/companyApi.js
import apiClient from './axios';

const companyApi = {
  // GET all (with pagination + search)
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/company/', {
      params: { page, page_size: pageSize, search },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  // GET by ID
  getById: async (id) => {
    const response = await apiClient.get(`/company/${id}/`);
    return response.data;
  },

  // CREATE
  create: async (data) => {
    const response = await apiClient.post('/company/', data);
    return response.data;
  },

  // UPDATE (PATCH)
  update: async (id, data) => {
    const response = await apiClient.patch(`/company/${id}/`, data);
    return response.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/company/${id}/`);
    return id;
  },

  /* -------------------------- EXPORT -------------------------- */
  exportCsv: async () => {
    const response = await apiClient.get('/company/export/', {
      responseType: 'blob',
    });
    return response.data; // Blob
  },

  /* -------------------------- IMPORT PREVIEW -------------------------- */
  importPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/company/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data; // { preview: [...], total: number }
  },

  /* -------------------------- IMPORT CONFIRM -------------------------- */
  importConfirm: async (preview) => {
    const response = await apiClient.post('/company/import-confirm/', { preview });
    return response.data;
  },
};

export default companyApi;